import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useJobs } from '../context/JobsContext';
import { getRecommendations } from '../services/recommendationService';
import { useNavigate } from 'react-router-dom';
import '../styles/recommendationsSection.css';

const RecommendationCard = ({ job, score, matchReasons, onClick }) => {
  return (
    <div className="recommendation-card" onClick={onClick}>
      <div className="rec-icon-wrapper">
        <img src={job.image} alt={job.title} className="rec-icon" />
      </div>
      
      <div className="rec-content">
        <h3>{job.title}</h3>
        <p className="rec-status">TBD</p>
        <span className="rec-job-type">{job.type}</span>
      </div>
    </div>
  );
};

const RecommendationsSection = () => {
  const { currentUser } = useAuth();
  const { jobs } = useJobs();
  const navigate = useNavigate();
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser || !jobs || jobs.length === 0) {
      console.log('[Recommendations] Missing data:', { 
        hasUser: !!currentUser, 
        jobsCount: jobs?.length || 0 
      });
      setLoading(false);
      return;
    }

    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        console.log('[Recommendations] Fetching for user:', currentUser.uid, 'With', jobs.length, 'jobs');
        const recs = await getRecommendations(currentUser.uid, jobs);
        console.log('[Recommendations] Got recommendations:', recs?.length || 0, recs);
        
        // Show top 6 recommendations for better space utilization
        const topRecs = recs && recs.length > 0 ? recs.slice(0, 6) : [];
        setRecommendations(topRecs);
      } catch (err) {
        console.error('[Recommendations] Error fetching:', err);
        setRecommendations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, [currentUser, jobs]);

  const handleJobClick = (jobId) => {
    localStorage.setItem('job', jobId);
    navigate(`/job-details/${jobId}`);
  };

  // Show section if user is logged in
  if (!currentUser) {
    return null;
  }
  
  if (loading) {
    return (
      <section className="recommendations-section">
        <div className="rec-header">
          <h2>Discover Opportunities</h2>
          <p>That match your skills</p>
        </div>
        <div className="rec-loading">
          <p>Finding perfect matches...</p>
        </div>
      </section>
    );
  }
  
  if (recommendations.length === 0) {
    return (
      <section className="recommendations-section">
        <div className="rec-header">
          <h2>Discover Opportunities</h2>
          <p>That match your skills</p>
        </div>
        <div className="rec-loading">
          <p>Complete applications to see personalized recommendations</p>
        </div>
      </section>
    );
  }

  return (
    <section className="recommendations-section">
      <div className="rec-header">
        <h2>Discover Opportunities</h2>
        <p>That match your skills</p>
      </div>
      
      <div className="recommendations-container">
        {recommendations.map((rec, idx) => (
          <RecommendationCard
            key={idx}
            job={rec.job}
            score={rec.score}
            matchReasons={rec.matchReasons}
            onClick={() => handleJobClick(rec.job.id)}
          />
        ))}
      </div>
    </section>
  );
};

export default RecommendationsSection;
